import { TranslationKey } from './../translation/TranslationKey';

import { VentoryColor } from '../../VentoryUI/util/color.util';
import { AssetTransaction, AssetTransactionParentType } from '../asset_transaction/assetTransaction';
import { t } from '../translation/Translator';
import { Asset } from './asset';

export namespace AssetUtil {
  export const statusToString = (
    asset: Asset,
    assets: Map<string, Asset>,
    assetTransactions: Map<string, AssetTransaction>,
  ) => {
    if (!assets.has(asset.id)) {
      const isTransaction = assetTransactions.get(asset.id);
      if (isTransaction) {
        if (isTransaction.parentType === AssetTransactionParentType.returnAsset)
          return t(TranslationKey.pendingReturn).singular.label;
        if (isTransaction.parentType === AssetTransactionParentType.assign)
          return t(TranslationKey.pendingAssign).singular.label;
        if (isTransaction.parentType === AssetTransactionParentType.manual)
          return t(TranslationKey.pendingAssign).singular.label;
      }
      return t(TranslationKey.pending).singular.label;
    }
    if (asset.location) return t(TranslationKey.issued).singular.label;
    return t(TranslationKey.available).singular.label;
  };

  export const statusToColorStyle = (asset: Asset, assets: Map<string, Asset>) => {
    if (!assets.has(asset.id)) {
      return {
        color: VentoryColor.yellow700,
        backgroundColor: VentoryColor.yellow50,
      };
    }

    if (asset.location) {
      return {
        color: VentoryColor.blue700,
        backgroundColor: VentoryColor.blue50,
      };
    }

    return {
      color: VentoryColor.green700,
      backgroundColor: VentoryColor.green50,
    };
  };
}
